<template>
    <div id="partner-box">
        <Header :hasLeft="false" pageTitle="知识合伙人" />
        <ul v-if="auditStatus == 2" class="partner-list">
            <li class="partner-item" @click="toApply(1, 2)">
                <!-- 电商业务 -->
                <img src="@/assets/img/mobile-img/partner/partner-list-1.png" alt="" />
                <span>合伙人收款商户Ⅰ</span>
            </li>
            <li class="partner-item" @click="toApply(2, 1)">
                <!-- 投审稿业务 -->
                <img src="@/assets/img/mobile-img/partner/partner-list-2.png" alt="" />
                <span>合伙人收款商户Ⅱ</span>
            </li>
            <div v-if="customerType != 2">
                <li class="partner-item" @click="toApply(3, 1, '图书商城')">
                    <img src="@/assets/img/mobile-img/partner/partner-list-3.png" alt="" />
                    <span>图书商城</span>
                </li>
                <li class="partner-item" @click="toApply(4, 2, '学术会议')">
                    <img src="@/assets/img/mobile-img/partner/partner-list-4.png" alt="" />
                    <span>学术会议</span>
                </li>
                <li class="partner-item" @click="toApply(5, 3, '教育培训')">
                    <img src="@/assets/img/mobile-img/partner/partner-list-5.png" alt="" />
                    <span>教育培训</span>
                </li>
                <li class="partner-item" @click="toApply(6, 4, '行业报告')">
                    <img src="@/assets/img/mobile-img/partner/partner-list-6.png" alt="" />
                    <span>行业报告</span>
                </li>
                <li class="partner-item" @click="toApply(7, 5, '知识付费-会议论文集')">
                    <img src="@/assets/img/mobile-img/partner/partner-list-7.png" alt="" />
                    <span>知识付费-会议论文集</span>
                </li>
                <li class="partner-item" @click="toApply(8, 6, '知识付费-学术期刊')">
                    <img src="@/assets/img/mobile-img/partner/partner-list-8.png" alt="" />
                    <span>知识付费-学术期刊</span>
                </li>
                <li class="partner-item" @click="toApply(9, 7)">
                    <img src="@/assets/img/mobile-img/partner/partner-list-9.png" alt="" />
                    <span>官网搭建</span>
                </li>
            </div>
        </ul>
        <div v-if="auditStatus === 0 || auditStatus == 1 || auditStatus == 3">
            <div class="partner-top">
                <van-button class="partner-btn" round type="info" @click="toVerify"
                    >成为知识合伙人</van-button
                >
            </div>
            <div class="partner-equity-box">
                <p class="partner-equity-title">知识合伙人权益</p>
                <ul>
                    <li class="equity-item">
                        <img
                            class="equity-item-img"
                            src="@/assets/img/mobile-img/partner/partner-1.png"
                            alt=""
                        />
                        <div>
                            <h3 class="equity-item-title">合伙人收款商户Ⅰ</h3>
                            <TextEllipsis
                                content="申请知识合伙人收款商户Ⅰ。申请成功后，您将获得专属收款商户，能够在中文知识网实现便捷、安全地收款。"
                            />
                        </div>
                    </li>
                    <li class="equity-item">
                        <img
                            class="equity-item-img"
                            src="@/assets/img/mobile-img/partner/partner-1.png"
                            alt=""
                        />
                        <div>
                            <h3 class="equity-item-title">合伙人收款商户Ⅱ</h3>
                            <TextEllipsis
                                content="申请知识合伙人收款商户Ⅱ。申请成功后，您将获得专属收款商户，能够在投审稿系统中实现便捷、安全地收款。"
                            />
                        </div>
                    </li>
                    <li class="equity-item">
                        <img
                            class="equity-item-img"
                            src="@/assets/img/mobile-img/partner/partner-2.png"
                            alt=""
                        />
                        <div>
                            <h3 class="equity-item-title">图书商城</h3>
                            <TextEllipsis
                                content="您将获得在中文知识网售卖图书的权益。自主选择优质的图书资源进行上架销售，通过便捷的平台系统管理库存和订单，同时享受平台提供的推广和营销支持，助力您的图书销售业务。"
                            />
                        </div>
                    </li>
                    <li class="equity-item">
                        <img
                            class="equity-item-img"
                            src="@/assets/img/mobile-img/partner/partner-3.png"
                            alt=""
                        />
                        <div>
                            <h3 class="equity-item-title">学术会议</h3>
                            <TextEllipsis
                                content="您将获得在中文知识网发布学术会议的权益。自主发布会议主题、议程、演讲嘉宾等重要内容，吸引相关领域的专业人士参与、报名。平台将为您提供高效的宣传渠道，扩大会议的影响力和参与度。"
                            />
                        </div>
                    </li>
                    <li class="equity-item">
                        <img
                            class="equity-item-img"
                            src="@/assets/img/mobile-img/partner/partner-5.png"
                            alt=""
                        />
                        <div>
                            <h3 class="equity-item-title">行业报告</h3>
                            <TextEllipsis
                                content="您将获得在中文知识网售卖行业报告的权益。发布具有价值的行业报告，自主定价，展示报告亮点，吸引有需求的用户进行购买。平台保障交易的安全与便捷，让您的知识成果实现商业价值。"
                            />
                        </div>
                    </li>
                    <li class="equity-item">
                        <img
                            class="equity-item-img"
                            src="@/assets/img/mobile-img/partner/partner-4.png"
                            alt=""
                        />
                        <div>
                            <h3 class="equity-item-title">教育培训</h3>
                            <TextEllipsis
                                content="您将获得在中文知识网发布教育培训课程的权益。无论是学术课程、专业技能培训还是兴趣爱好类课程，都可以在平台上展示和推广。您可以自由设定课程价格、安排授课时间和方式，借助平台将您的知识和经验传递给更多的学习者。"
                            />
                        </div>
                    </li>
                    <li class="equity-item">
                        <img
                            class="equity-item-img"
                            src="@/assets/img/mobile-img/partner/partner-6.png"
                            alt=""
                        />
                        <div>
                            <h3 class="equity-item-title">知识付费-会议论文集</h3>
                            <TextEllipsis
                                content="您将获得在中文知识网发布会议论文的权益。上传会议论文集文献，其他用户可以进行购买，让您的研究成果得以变现。平台会为论文集提供展示空间和推广渠道，增加其曝光度，吸引更多有需求的读者，实现您的知识价值最大化。注：该权益需结合学术会议权益使用"
                            />
                        </div>
                    </li>
                    <li class="equity-item">
                        <img
                            class="equity-item-img"
                            src="@/assets/img/mobile-img/partner/partner-6.png"
                            alt=""
                        />
                        <div>
                            <h3 class="equity-item-title">知识付费-学术期刊</h3>
                            <TextEllipsis
                                content="您将获得在中文知识网期刊论文知识付费的权益。用户可以购买您的期刊论文。平台会为论文集提供展示空间和推广渠道，增加其曝光度，吸引更多有需求的读者，实现您的知识价值最大化。"
                            />
                        </div>
                    </li>
                    <li class="equity-item">
                        <img
                            class="equity-item-img"
                            src="@/assets/img/mobile-img/partner/partner-7.png"
                            alt=""
                        />
                        <div>
                            <h3 class="equity-item-title">官网搭建</h3>
                            <div class="equity-item-text">多站点统一管理的网站群系统</div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <TipsDialog
            :showDialog="showDialog"
            confirmBtn="前往认证"
            @dialogCancel="showDialog = false"
            @dialogConfirm="dialogConfirm"
        >
            <p>当前您的账号未完成身份认证，如需成为知识合伙人，请先完成认证</p>
        </TipsDialog>
    </div>
</template>
<script>
import Header from "@/views/mobileView/components/header";
import TextEllipsis from "./components/TextEllipsis";
import TipsDialog from "@/views/mobileView/components/tipsDialog.vue";
export default {
    name: "PartnerBox",
    components: {
        Header,
        TextEllipsis,
        TipsDialog,
    },
    data() {
        return {
            auditStatus: "",
            showDialog: false,
            equityList: [],
            customerType: "",
        };
    },
    created() {
        this.getPartnerDetail();
    },
    methods: {
        toApply(index, type, title) {
            let equityObj = this.equityList.filter((item) => item.index == index)[0];
            console.log(equityObj, "equityObj");
            if (index === 1 || index === 2) {
                this.toService(type);
            } else if (index === 9) {
                this.toWebsiteBuild(equityObj);
            } else {
                if (equityObj.statusCode === -1) {
                    this.$router.push(`/partner/partner-equity?type=${type}&title=${title}`);
                } else {
                    this.$router.push(`/partner/equity-result?type=${type}&title=${title}`);
                }
            }
        },
        async toService(type) {
            const res = await this.$apis.zzsignServe.signProgress({ type });
            if (res.data && res.data.resCode === "0000") {
                const { applyStatus, umsRegId, applyStatusMsg } = res.data;
                switch (applyStatus) {
                    case "00":
                        this.$router.push(
                            `/service-sign/agreement-sign?type=${type}&umsRegId=${umsRegId}`
                        );
                        break;
                    case "05":
                        this.$router.push(
                            `/service-sign/public-verification?type=${type}&umsRegId=${umsRegId}`
                        );
                        break;
                    case "02":
                    case "03":
                    case "04":
                        this.$router.push(
                            `/service-sign/sign-result?type=${type}&umsRegId=${umsRegId}`
                        );
                        break;
                    default:
                        Toast(applyStatusMsg);
                        break;
                }
            } else {
                this.$router.push(`/service-sign?type=${type}`);
            }
        },
        toWebsiteBuild(equityObj) {
            if (equityObj.statusCode === -1) {
                this.$router.push(`/partner/partner-equity-website`);
            } else {
                this.$router.push(`/partner/equity-website-result`);
            }
        },
        async dialogConfirm() {
            const { data = { status: 999 } } = await this.$apis.userServe.authStatus(2);
            if (data.status === 0) {
                // 审核中
                this.$router.push({
                    path: "scholarStatus",
                    query: { title: "期刊认证" },
                });
            } else if (data.status === 2) {
                // 审核失败
                this.$router.push({
                    name: "scholarFail",
                    query: {
                        cause: data.cause,
                        title: "期刊认证",
                    },
                });
            } else {
                this.$router.push("authentication");
            }
        },
        async getPartnerDetail() {
            if (sessionStorage.getItem("token")) {
                let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
                this.customerType = userInfo.user.customerType; // 1 普通用户 2学者 4 期刊 5 机构 没有 子账号
                const res = await this.$apis.userServe.getPartnerDetail();
                if (res.resultCode === "200") {
                    if (res.data) {
                        if (res.data.review) {
                            this.auditStatus = res.data.review.auditStatus;
                        } else {
                            this.auditStatus = 0;
                        }
                        res.content.businessList[5].statusCode = -1;
                        this.equityList = [...res.content.businessList, ...res.content.merchant];
                    } else {
                        this.auditStatus = 0;
                    }
                } else {
                    this.auditStatus = 0;
                }
            } else {
                this.auditStatus = 0;
            }
        },
        toVerify() {
            if (sessionStorage.getItem("token")) {
                switch (this.auditStatus) {
                    case 0:
                        if (
                            this.customerType == 2 ||
                            this.customerType == 4 ||
                            this.customerType == 5
                        ) {
                            this.$router.push({
                                path: "/partner/form-service",
                                query: { customerType: this.customerType },
                            });
                        } else {
                            this.showDialog = true;
                        }
                        break;
                    case 1:
                    case 3:
                        this.$router.push({
                            path: "/partner/partner-result",
                            query: { customerType: this.customerType },
                        });
                        break;
                }
            } else {
                this.$router.push("/logins");
            }
        },
    },
};
</script>
<style lang="scss" scoped>
#partner-box {
    padding: 44px 0 24px;
    color: #333;
    .partner-top {
        position: relative;
        width: 100%;
        height: 292px;
        background-image: url("~@/assets/img/mobile-img/partner/partner-top.png");
        background-size: 100%;
        background-repeat: no-repeat;
        .partner-btn {
            position: absolute;
            bottom: 10px;
            left: 25px;
            width: 325px;
            height: 44px;
            font-size: 16px;
            font-weight: 500;
        }
    }
    .partner-equity-box {
        margin: 0 auto;
        padding: 20px 15px 0;
        width: 351px;
        background-color: #ffffff;
        border-radius: 8px;
        overflow: hidden;
        .partner-equity-title {
            margin-bottom: 15px;
            font-weight: 500;
            font-size: 16px;
            color: #333333;
        }
        .equity-item {
            display: flex;
            margin-bottom: 12px;
            padding: 15px;
            width: 100%;
            border-radius: 6px;
            background-color: #f0f6ff;
            .equity-item-img {
                flex: none;
                margin-right: 12px;
                width: 24px;
                height: 24px;
            }
            .equity-item-title {
                margin-bottom: 12px;
                font-size: 15px;
                color: #333333;
            }
            .equity-item-text {
                font-size: 13px;
                color: #666666;
            }
        }
    }
    .partner-list {
        padding: 12px;
        .partner-item {
            display: flex;
            align-items: center;
            margin-bottom: 12px;
            padding: 18px 15px;
            width: 100%;
            background-color: #ffffff;
            border-radius: 8px;
            &:last-child {
                margin-bottom: 0;
            }
            img {
                width: 30px;
                height: 30px;
            }
            span {
                margin-left: 13px;
                font-weight: 700;
                font-size: 16px;
                color: #333333;
            }
        }
    }
}
</style>
